import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, Popover, Whisper, FlexboxGrid } from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import TooltipButton from '../../../components/buttons/TooltipButton'
import InputForm from '../../../components/forms/input/InputForm'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import EditFormDescriptionWidget from './EditFormDescriptionWidget'
import InputSelectForm from '../../../components/forms/input/InputSelectForm'
import CustomAlertMessage from '../../CustomAlertMessage'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'

export default function SettingEditFormListWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  datas,
  buttonText,
  inputMode,
  required,
  //key,
  hideDescription,
  hideDescriptionSetting,
  hideResultType,
  fixedResultType,
  enableAddSub = true,
  enableChoice,
  newObjectsName = 'newObjects',
  newObjectsValuesName = 'newObjectsValuesName',
  moreTxt = 'ส่วนเสริม',
  childTxt = 'ข้อย่อย',
  choiceTxt = 'ตัวเลือก',
  setLoading = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  // const [objects, setObjects] = useState([])
  const [newObjects, setNewObjects] = useState([])
  const [newObjectsValues, setNewObjectsValues] = useState(new Map())
  const [objectIndex, setObjectIndex] = useState(0)

  useEffect(() => {
    let data = datas || _schema?.objects || _schema?.values || []
    let objMap = new Map()
    // datas.forEach((e) => {
    //   maps.set(e.id, e)
    //    e.childs
    // })
    setDataToMap(data, objMap)
    setNewObjectsValues(objMap)
    setNewObjects(data)
    // console.log(
    //   'newObjectsValuesName : ',
    //   newObjectsValuesName,
    //   ' , SettingEditFormListWidget : ',
    //   _schema
    // )
    // console.log('objMap : ', objMap)
    setValue(newObjectsValuesName, objMap)
    setValue(newObjectsName, data)
  }, [_schema])

  const setDataToMap = (datas, objMap) => {
    datas?.forEach((e) => {
      objMap.set(e.id, e)

      e.moreInputs?.forEach((se) => {
        objMap.set(se.id, se)
      })

      if (e.childs) {
        setDataToMap(e.childs, objMap)
      }
    })
  }

  const renderInnerInput = (index, item, isMore, parentId) => {
    // console.log('isMore : ', isMore)
    // console.log('renderInnerInput item : ', item)
    // console.log('newObjectsValues : ', newObjectsValues)
    return (
      <>
        <FlexboxGrid>
          {isMore && index == 0 && (
            <FlexboxGrid.Item componentClass={Col} colspan={24} xs={24} sm={24} md={24} lg={24}>
              <label style={{ fontSize: '0.8rem' }}>
                <u>
                  <i>{moreTxt}</i>
                </u>
              </label>
            </FlexboxGrid.Item>
          )}

          {schema.inputFrom.section1 && (
            // <Col xs={24} sm={24} md={12} lg={14}>
            <FlexboxGrid.Item
              componentClass={Col}
              colspan={24}
              xs={24}
              sm={24}
              md={hideResultType ? 16 : 12}
              lg={hideResultType ? 16 : 14}
            >
              <InputForm
                hideLabel
                schema={schema.inputFrom.section1}
                name={item.id + schema.inputFrom.section1.name}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
                placeholder={isMore ? `${moreTxt}ของ ${schema.inputFrom.section1.label}` : ''}
                // inputWidth={350}
                value={newObjectsValues?.get(item.id)?.section1}
                onChange={(value) => {
                  let nObj = cloneDeep(newObjectsValues)
                  nObj.get(item.id).section1 = value

                  setNewObjectsValues(nObj)

                  setValue(newObjectsValuesName, nObj)
                }}
                style={{ marginLeft: isMore ? 20 : 0 }}
              />
              {/* </Col> */}
            </FlexboxGrid.Item>
          )}

          {/* <Col xs={24} sm={24} md={11} lg={9}> */}
          <FlexboxGrid.Item
            componentClass={Col}
            colspan={24}
            xs={24}
            sm={24}
            md={hideResultType ? 7 : 11}
            lg={hideResultType ? 7 : 9}
          >
            <div style={{ marginTop: 5 }}>
              {/* <FormGroup> */}
              <Row style={{ marginTop: -5 }}>
                {!hideResultType && schema.inputFrom.resultType && (
                  <Col xs={24} sm={24} md={10} lg={10}>
                    {/* <span style={{ marginLeft: 10 }}></span> */}
                    <InputSelectForm
                      hideLabel
                      schema={schema.inputFrom.resultType}
                      name={item.id + '_' + schema.inputFrom.resultType.name}
                      register={register}
                      Controller={Controller}
                      control={control}
                      errors={errors}
                      setValue={setValue}
                      clearErrors={clearErrors}
                      value={newObjectsValues?.get(item.id)?.resultType}
                      onChange={(value) => {
                        let nObj = cloneDeep(newObjectsValues)
                        nObj.get(item.id).resultType = value

                        if (value != '1') {
                          nObj.get(item.id).unit = ''
                        }

                        setNewObjectsValues(nObj)
                        setValue(newObjectsValuesName, nObj)
                      }}
                    />
                  </Col>
                )}
                {newObjectsValues?.get(item.id)?.resultType && (
                  <>
                    {schema.inputFrom.result &&
                      ((newObjectsValues?.get(item.id)?.resultType != '1' && !inputMode) ||
                        newObjectsValues?.get(item.id)?.resultType == '1') && (
                        <Col xs={24} sm={24} md={6} lg={6}>
                          <InputForm
                            hideLabel
                            schema={schema.inputFrom.result}
                            name={item.id + schema.inputFrom.result.name}
                            register={register}
                            Controller={Controller}
                            control={control}
                            errors={errors}
                            setValue={setValue}
                            clearErrors={clearErrors}
                            isInputNumber={newObjectsValues?.get(item.id)?.resultType == '1'}
                            inputWidth={
                              newObjectsValues?.get(item.id)?.resultType == '1' ? 100 : null
                            }
                            value={newObjectsValues?.get(item.id)?.result}
                            onChange={(value) => {
                              let nObj = cloneDeep(newObjectsValues)
                              nObj.get(item.id).result = value
                              setNewObjectsValues(nObj)
                              setValue(newObjectsValuesName, nObj)
                            }}
                          />
                        </Col>
                      )}

                    {newObjectsValues?.get(item.id)?.resultType == '1' && schema.inputFrom.unit && (
                      <Col xs={24} sm={24} md={hideResultType ? 8 : 6} lg={hideResultType ? 8 : 6}>
                        <InputForm
                          hideLabel
                          schema={schema.inputFrom.unit}
                          name={item.id + schema.inputFrom.unit.name}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          inputWidth={120}
                          value={newObjectsValues?.get(item.id)?.unit}
                          onChange={(value) => {
                            let nObj = cloneDeep(newObjectsValues)
                            nObj.get(item.id).unit = value
                            setNewObjectsValues(nObj)
                            setValue(newObjectsValuesName, nObj)
                          }}
                        />
                      </Col>
                    )}
                  </>
                )}
                {isMore && (
                  <Col xs={24} sm={24} md={2} lg={2}>
                    <TooltipButton
                      isStart={true}
                      icon="trash-o"
                      tooltip={`ลบ${moreTxt}`}
                      style={{
                        marginLeft: 10,
                        marginTop: 8,
                      }}
                      // children={`ลบ${moreTxt}`}
                      buttonClass="rs-btn-ghost-cancel"
                      iconClass={'bt-gost-icon-radius-all-cancel'}
                      onClick={() => onRemoveMoreInputs(item, parentId)}
                    />
                  </Col>
                )}
              </Row>

              {/* </FormGroup> */}
            </div>
          </FlexboxGrid.Item>
          {/* <Col xs={24} sm={24} md={1} lg={1} style={{ textAlign: 'right' }}> */}
          <FlexboxGrid.Item
            componentClass={Col}
            colspan={24}
            xs={24}
            sm={24}
            md={1}
            lg={1}
            style={{ textAlign: 'right' }}
          >
            {!isMore && (
              <Whisper
                trigger="click"
                placement={'bottom'}
                speaker={
                  <Popover title="" style={{ minWidth: 150, maxWidth: 200 }}>
                    {newObjectsValues?.get(item.id)?.resultType == '1' && !inputMode && (
                      <SaveButton
                        icon="plus"
                        style={{
                          marginTop: 5,
                          marginBottom: 5,
                          width: '100%',
                        }}
                        children={`เพิ่ม${moreTxt}`}
                        onClick={() => onAddMoreInputs(item)}
                      />
                    )}

                    {enableAddSub &&
                      !inputMode &&
                      !item.isOption &&
                      !item.childs?.find((e) => e.isOption == true) && (
                        <>
                          <ViewButton
                            icon="plus"
                            style={{
                              marginTop: 5,
                              marginBottom: 5,
                              width: '100%',
                            }}
                            buttonClass="rs-btn-ghost-info"
                            iconClass={'bt-gost-icon-radius-all-info'}
                            children={`เพิ่ม${childTxt}`}
                            onClick={() => onAddSub(item, false)}
                          />
                        </>
                      )}

                    {enableChoice &&
                      !inputMode &&
                      !item.isOption &&
                      !item.childs?.find((e) => e.isSection == true) && (
                        <>
                          <ViewButton
                            icon="plus"
                            style={{
                              marginTop: 5,
                              marginBottom: 5,
                              width: '100%',
                            }}
                            buttonClass="rs-btn-ghost-edit"
                            iconClass={'bt-gost-icon-radius-all-edit'}
                            children={`เพิ่ม${choiceTxt}`}
                            onClick={() => onAddSub(item, true)}
                          />
                        </>
                      )}

                    <CancelButton
                      isStart={true}
                      icon="trash-o"
                      tooltip={`ลบ${schema?.inputFrom?.section1?.label || ''}`}
                      style={{
                        marginTop: 5,
                        marginBottom: 5,
                        width: '100%',
                      }}
                      buttonClass="rs-btn-ghost-cancel"
                      iconClass={'bt-gost-icon-radius-all-cancel'}
                      children={`ลบ${
                        enableChoice && item.isOption
                          ? choiceTxt
                          : schema?.inputFrom?.section1?.label || ''
                      }`}
                      onClick={() => onRemoveInputs(item, index)}
                    />
                  </Popover>
                }
              >
                <TooltipButton
                  isStart={true}
                  icon="ellipsis-h"
                  tooltip={`จัดการ`}
                  style={{
                    marginTop: 5,
                  }}
                />
              </Whisper>
            )}
          </FlexboxGrid.Item>

          {/* </Col> */}
        </FlexboxGrid>
        {item.moreInputs?.map((subItem, index) => {
          return <>{renderInnerInput(index, subItem, true, item.id)}</>
        })}
      </>
    )
  }

  const renderInputs = (datas, number, tabRight) => {
    return (
      <>
        {datas?.map((item, index) => {
          return (
            <Panel
              bordered
              style={{
                marginTop: 10,
                marginBottom: 10,
                marginLeft: tabRight ? 20 : undefined,
                backgroundColor: '#e2f9ff',
              }}
              // shaded={!tabRight}
              shaded
              // header={
              //   tabRight
              //     ? `${childTxt}ที่ ${number}${index + 1}`
              //     : `${buttonText || schema?.header || 'ข้อที่'} ${index + 1}`
              // }
            >
              <div style={{ marginTop: 0 }}>
                {tabRight && (
                  <Row>
                    <label style={{ fontSize: '0.8rem' }}>
                      <u>
                        <i>
                          {enableChoice && item.isOption
                            ? `${choiceTxt}ที่ ${index + 1}`
                            : `${childTxt}ที่ ${number}${index + 1}`}
                        </i>
                      </u>
                    </label>
                  </Row>
                )}
                <Row style={{ marginLeft: -10, marginBottom: -10, marginRight: -10 }}>
                  {/* <Form layout="inline"> */}
                  {renderInnerInput(index, item, false)}
                  {/* </Form> */}

                  {item.childs && renderInputs(item.childs, `${number || ''}${index + 1}.`, true)}
                </Row>
              </div>
            </Panel>
          )
        })}
      </>
    )
  }

  const setMoreInputsItem = (datas, item) => {
    datas?.forEach((element, index) => {
      // console.log('element : ', element)
      // console.log('Id : ', `${element.id}_${index}`)
      if (element.id == item.id) {
        // let lastId
        // if (element.moreInputs.length > 0) {
        //   let lastObj = element.moreInputs[element.moreInputs.length - 1]
        //   let ids = lastObj.id.split('-')
        //   lastId = parseInt(ids[ids.length - 1]) + 1
        // } else {
        //   lastId = 0
        // }

        let newObj = {
          id: `NEW_${objectIndex + 1}`,
          section1: '',
          resultType: '',
          result: '',
          unit: '',
          moreInputs: [],
          childs: [],
          parentId: item.id,
        }

        element.moreInputs.push(newObj)

        let newObjectInput = cloneDeep(newObjectsValues || new Map())
        newObjectInput.set(newObj.id, newObj)
        setNewObjectsValues(newObjectInput)

        setObjectIndex(objectIndex + 1)
        setValue(newObjectsValuesName, newObjectInput)
        return
      } else if (element.childs) {
        setMoreInputsItem(element.childs, item)
      }
    })
  }

  const removeMoreInputsItem = (datas, item, parentId) => {
    // console.log('removeMoreInputsItem datas : ', datas)
    // console.log('removeMoreInputsItem : ', parentId)

    datas?.forEach((element, index) => {
      if (element.id == parentId) {
        let itemIndex = element.moreInputs.findIndex((e) => e.id == item.id)
        // console.log('itemIndex : ', itemIndex)
        element.moreInputs.splice(itemIndex, 1)

        let newObjectInput = cloneDeep(newObjectsValues)
        newObjectInput.delete(item.id)
        setNewObjectsValues(newObjectInput)

        setValue(newObjectsValuesName, newObjectInput)

        return
      } else if (element.childs) {
        removeMoreInputsItem(element.childs, item, parentId)
      }
    })
  }

  const removeInputsItem = (datas, item) => {
    // console.log('removeInputsItem datas : ', datas)
    // console.log('removeInputsItem : ', item)
    let itemIndex = datas.findIndex((e) => e.id == item.id)
    if (itemIndex >= 0) {
      datas.splice(itemIndex, 1)
    } else {
      datas?.forEach((element) => {
        if (element.id == item.parentId) {
          let itemIndex = element.childs.findIndex((e) => e.id == item.id)
          // console.log('itemIndex : ', itemIndex)
          element.childs.splice(itemIndex, 1)

          let newObjectInput = cloneDeep(newObjectsValues)
          newObjectInput.delete(item.id)
          setNewObjectsValues(newObjectInput)

          setValue(newObjectsValuesName, newObjectInput)

          return
        } else if (element.childs) {
          removeInputsItem(element.childs, item)
        }
      })
    }
  }

  const onAddMoreInputs = (item) => {
    let newObject = cloneDeep(newObjects || [])
    // console.log('onAddMoreInputs item : ', item)
    setMoreInputsItem(newObject, item, item.id)
    // setChildsItem2(newObject, item)
    setNewObjects(newObject)
    setValue(newObjectsName, newObject)
  }

  const onRemoveMoreInputs = (item, parentId) => {
    let newObject = cloneDeep(newObjects || [])
    // console.log('onRemoveMoreInputs item : ', item, ' parentId : ', parentId)
    removeMoreInputsItem(newObject, item, parentId)
    // setChildsItem2(newObject, item)
    setNewObjects(newObject)
    setValue(newObjectsName, newObject)
  }

  const onRemoveInputs = (item) => {
    let newObject = cloneDeep(newObjects || [])
    // console.log('onRemoveInputs item : ', item)
    removeInputsItem(newObject, item)
    // setChildsItem2(newObject, item)
    // console.log('newObject item : ', newObject)
    setNewObjects(newObject)

    setValue(newObjectsName, newObject)
  }

  const setChildsItem = (datas, item, masterId, isChoice) => {
    datas?.forEach((element, index) => {
      // console.log('element : ', element)
      // console.log('Id : ', `${element.id}_${index}`)
      if (element.id == item.id) {
        // let lastId
        // if (element.childs.length > 0) {
        //   let lastObj = element.childs[element.childs.length - 1]
        //   let ids = lastObj.id.split('_')
        //   lastId = parseInt(ids[ids.length - 1]) + 1
        // } else {
        //   lastId = 0
        // }
        // console.log('element.childs.length : ', element.childs.length)
        // console.log('lastId : ', lastId)
        let lastEm = element.childs[element.childs.length - 1]

        let newObj = {
          id: `NEW_${objectIndex + 1}`,
          parentId: lastEm?.parentId,
          section1: null,
          resultType: fixedResultType || null,
          result: null,
          unit: null,
          isSection: !isChoice,
          isOption: isChoice,
          moreInputs: [],
          childs: [],
        }

        element.childs.push(newObj)

        let newObjectInput = cloneDeep(newObjectsValues || new Map())
        newObjectInput.set(newObj.id, newObj)

        setNewObjectsValues(newObjectInput)
        setObjectIndex(objectIndex + 1)
        setValue(newObjectsValuesName, newObjectInput)

        return
      } else if (element.childs) {
        setChildsItem(element.childs, item, element.id, isChoice)
      }
    })
  }

  const onAddSub = (item, isChoice) => {
    let newObject = cloneDeep(newObjects || [])
    //console.log('onAddSub item : ', item)
    setChildsItem(newObject, item, item.id, isChoice)
    // setChildsItem2(newObject, item)
    //console.log('newObject item : ', newObject)
    setNewObjects(newObject)

    setValue(newObjectsName, newObject)
  }

  const handleAdd = () => {
    let newObject = cloneDeep(newObjects || [])
    let newObjectInput = cloneDeep(newObjectsValues || new Map())
    //let newId = 'NEW_' + newObject.length

    // let lastId
    // if (newObject.length > 0) {
    //   let lastObj = newObject[newObject.length - 1]
    //   let ids = lastObj.id.split('_')
    //   lastId = parseInt(ids[ids.length - 1]) + 1
    // } else {
    //   lastId = 0
    // }

    let newInput = {
      id: 'NEW_' + (objectIndex + 1),
      parentId: null,
      section1: null,
      resultType: fixedResultType || null,
      result: null,
      unit: null,
      isSection: true,
      isOption: false,
      moreInputs: [],
      childs: [],
    }
    newObject.push(newInput)

    newObjectInput.set(newInput.id, newInput)

    // console.log('newObjectInput : ', newObjectInput)
    // console.log('newObject : ', newObject)

    setNewObjectsValues(newObjectInput)
    setNewObjects(newObject)
    setObjectIndex(objectIndex + 1)

    setValue(newObjectsValuesName, newObjectInput)
    setValue(newObjectsName, newObject)
    // setIsAddNew(true)
  }

  return (
    <Panel
      header={props.header}
      collapsible={props.collapsible}
      defaultExpanded={props.defaultExpanded}
      bordered={props.bordered}
      style={{ marginBottom: 20 }}
    >
      <Row style={{ marginTop: -10 }}>
        {!hideDescription && schema?.description && (
          <Col style={{ marginBottom: 10 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}
      </Row>

      {!hideDescriptionSetting && schema.descriptionSetting && (
        <EditFormDescriptionWidget
          schema={schema.descriptionSetting}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      )}

      <Controller
        key={newObjectsName}
        name={newObjectsName}
        control={control}
        defaultValue={newObjects}
        values={newObjects}
      />

      <Controller
        key={newObjectsValuesName}
        name={newObjectsValuesName}
        control={control}
        defaultValue={newObjectsValues}
        values={newObjectsValues}
      />

      {newObjects && renderInputs(newObjects)}

      {required && newObjects?.length < 1 && (
        <ErrorMessage
          error={{ message: `กรุณา เพิ่ม${buttonText || schema?.header || ''}` }}
          style={{ marginBottom: 10 }}
        />
      )}
      <SaveButton
        icon="plus"
        children={`เพิ่ม${buttonText || schema?.header || ''}`}
        onClick={handleAdd}
      />
    </Panel>
  )
}
